import React, { FC } from 'react';

import styles from './styles.module.scss';

type Props = {
  children?: React.ReactNode;
};

const ContentOnly: FC<Props> = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default ContentOnly;
